export function parseOptionalPositiveRouteId(value: unknown): number | undefined {
  const rawValue = Array.isArray(value) ? value[0] : value;
  if (typeof rawValue !== "string" || rawValue.trim() === "") {
    return undefined;
  }
  const id = Number(rawValue);
  return Number.isInteger(id) && id > 0 ? id : undefined;
}
